// Storage service - localStorage wrapper for React Native compatibility
import { API_CONFIG } from '../config/api.config';

const KEYS = {
    API_KEY: 'openrouter_api_key',
    SELECTED_MODEL: 'selected_model',
    HAS_ONBOARDED: 'hasOnboarded',
    BASELINE_DATA: 'baselineData',
    CALIBRATION_DATA: 'calibrationData',
    ANALYSIS_HISTORY: 'analysisHistory',
};

export const storage = {
    // API Key
    getApiKey: () => localStorage.getItem(KEYS.API_KEY) || '',
    setApiKey: (key) => localStorage.setItem(KEYS.API_KEY, key),

    // Model selection
    getSelectedModel: () => localStorage.getItem(KEYS.SELECTED_MODEL) || API_CONFIG.DEFAULT_MODEL,
    setSelectedModel: (model) => localStorage.setItem(KEYS.SELECTED_MODEL, model),

    // Onboarding
    hasOnboarded: () => localStorage.getItem(KEYS.HAS_ONBOARDED) === 'true',
    setOnboarded: () => localStorage.setItem(KEYS.HAS_ONBOARDED, 'true'),

    // Baseline data
    getBaselineData: () => {
        const saved = localStorage.getItem(KEYS.BASELINE_DATA);
        return saved ? JSON.parse(saved) : { established: false, daysCompleted: 0, totalDays: 7, data: [] };
    },
    setBaselineData: (data) => localStorage.setItem(KEYS.BASELINE_DATA, JSON.stringify(data)),

    // Calibration data
    getCalibrationData: () => {
        const saved = localStorage.getItem(KEYS.CALIBRATION_DATA);
        return saved ? JSON.parse(saved) : { calibrated: false, accuracy: 0, lastUpdate: null };
    },
    setCalibrationData: (data) => localStorage.setItem(KEYS.CALIBRATION_DATA, JSON.stringify(data)),

    // Analysis history
    getHistory: () => {
        const saved = localStorage.getItem(KEYS.ANALYSIS_HISTORY);
        return saved ? JSON.parse(saved) : [];
    },
    setHistory: (history) => localStorage.setItem(KEYS.ANALYSIS_HISTORY, JSON.stringify(history)),

    // Clear all data
    clearAll: () => localStorage.clear(),
};

export default storage;
